import { Component } from '@angular/core';
import { ContractorListComponent } from './contractor-list/contractor-list.component';

@Component({
  selector: 'app-contractor-view',
  imports: [ContractorListComponent],
  templateUrl: './contractors-view.component.html',
  styleUrl: './contractors-view.component.scss'
})
export class ContractorViewComponent {

}
